import React, { PropsWithChildren } from "react";
//#region types
import { EntityCardLayoutProps } from "models/propTypes/pageLayoutPropTypes";
import { EntityCardLayoutConstants, FileConstants, HTMLConstants } from "utils/constants";
//#endregion
//#region components
import { Grid } from "@mui/material";
import useScrollPosition from "../useScrollPosition";
import ViewPanel from "../panels/viewPanel";
import TitledContainerWrapper from "../panels/titledContainerWrapper";
import { useThrottledCallback } from "use-debounce";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const EntityCardLayout: React.FC<PropsWithChildren<EntityCardLayoutProps>> = (props) => {
  const listenToScroll = (scrollPosition: number) => {
    if (scrollPosition > 16) {
      document.querySelector(`.${cssExports.fullScreenDialog}`)?.classList.add(cssExports.scrolling);
    } else {
      document.querySelector(`.${cssExports.fullScreenDialog}`)?.classList.remove(cssExports.scrolling);
    }
  };

  const listenToScrollThrottle = useThrottledCallback(listenToScroll, 100);

  useScrollPosition(`#${FileConstants.DialogContentFullScreenId}`, listenToScrollThrottle);

  /** Since we use document.getElementById in the child components this component need to make sure this component is fully rendered first */
  const [enableChildren, setEnableChildren] = React.useState(false);
  React.useEffect(() => setEnableChildren(true), []);

  return (
    <Grid
      container
      direction="row"
      justifyContent="center"
      className={clsx(cssExports.fullScreenCardLayout, props.className)}
      columnGap={3}
      id={FileConstants.FileViewerFullScreenId}
      wrap="nowrap"
    >
      <Grid
        container
        item
        className={clsx(
          cssExports.fullScreenCardContent,
          props.widerCardLayout ? cssExports.fullScreenCardContentWider : undefined
        )}
        alignContent="flex-start"
      >
        <Grid container item spacing={{ xs: 2, sm: 2, md: 3 }}>
          <Grid container item>
            <ViewPanel
              elementId={EntityCardLayoutConstants.TopTodoCardId}
              className={cssExports.topTodoCardContent}
            ></ViewPanel>
          </Grid>
          <Grid container item id={EntityCardLayoutConstants.BetweenCardsContentId}></Grid>
          <Grid id={EntityCardLayoutConstants.MainContentToggleId} container item justifyContent="center"></Grid>
          <Grid container item id={HTMLConstants.MessagesId}></Grid>
          <Grid id={EntityCardLayoutConstants.MainCardContentContainerId} container item>
            <TitledContainerWrapper elementId={EntityCardLayoutConstants.MainCardContentId}></TitledContainerWrapper>
          </Grid>
          <Grid id={EntityCardLayoutConstants.InfoViwerContentContainerId} container item>
            <Grid container id={EntityCardLayoutConstants.InfoViewerSmallId} className={cssExports.infoViewer}></Grid>
          </Grid>
          <Grid id={EntityCardLayoutConstants.OtherContentId} spacing={3} container item></Grid>
        </Grid>
        <Grid container item id={EntityCardLayoutConstants.FooterId} className={cssExports.footerContainer}></Grid>
      </Grid>
      <Grid
        item
        id={EntityCardLayoutConstants.InfoViewerId}
        className={clsx(cssExports.infoViewer, props.hasInfoViewerInitially ? cssExports.hasContent : "")}
      ></Grid>

      {enableChildren ? props.children : <></>}
    </Grid>
  );
};

export default EntityCardLayout;
